interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1).filter(
    (p) => p === 1 || p === totalPages || Math.abs(p - page) <= 1,
  );

  const items: (number | string)[] = [];
  pages.forEach((p, i) => {
    if (i > 0 && p - pages[i - 1] > 1) items.push(`gap-${p}`);
    items.push(p);
  });

  return (
    <div className="flex flex-wrap items-center justify-center gap-2 mt-10">
      <button
        type="button"
        disabled={page === 1}
        onClick={() => onChange(page - 1)}
        className="w-9 h-9 rounded-md bg-background-100 border border-background-200 text-foreground-700 flex items-center justify-center cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed hover:border-background-300 transition-colors"
      >
        <i className="ri-arrow-left-s-line" />
      </button>
      {items.map((item) =>
        typeof item === 'number' ? (
          <button
            key={item}
            type="button"
            onClick={() => onChange(item)}
            className={`w-9 h-9 rounded-md text-sm font-label cursor-pointer border transition-colors ${
              item === page
                ? 'bg-primary-500 border-primary-500 text-foreground-950'
                : 'bg-background-100 border-background-200 text-foreground-700 hover:border-background-300'
            }`}
          >
            {item}
          </button>
        ) : (
          <span key={item} className="w-6 text-center text-foreground-500">
            ···
          </span>
        ),
      )}
      <button
        type="button"
        disabled={page === totalPages}
        onClick={() => onChange(page + 1)}
        className="w-9 h-9 rounded-md bg-background-100 border border-background-200 text-foreground-700 flex items-center justify-center cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed hover:border-background-300 transition-colors"
      >
        <i className="ri-arrow-right-s-line" />
      </button>
    </div>
  );
}